<template>
  <div class="tokyo_tm_home modern-home">
    <div class="home_content">
      <div class="avatar modern-avatar">
        <div
          class="image avatar_img"
          :style="{ backgroundImage: 'url(' + src1 + ')' }"
        ></div>
      </div>
      <div class="details modern-details">
        <h3 class="name animate-text">Touch Designs</h3>
        <div class="tagline">
          <span class="highlight">Since 2005</span>
        </div>
        <p class="job">
          Committed to understanding your requirements, managing your expectations and building a long-term relationship.
        </p>
        <div class="cta-buttons">
          <a href="#gallery" class="modern-btn primary">View Gallery</a>
          <a href="#contact" class="modern-btn secondary">Get in Touch</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    components: {
    },
    data() {
      return {
        src1: require("../assets/img/portfolio/2.jpg"),
      };
    },
  };
</script>

<style lang="scss" scoped>
.modern-home {
  .home_content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 40px;
    padding: 40px 20px;
  }

  .modern-avatar {
    position: relative;

    .avatar_img {
      width: 280px;
      height: 280px;
      border-radius: 20px;
      background-size: cover !important;
      background-position: center !important;
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
      position: relative;
      overflow: hidden;
    }
  }

  .modern-details {
    text-align: center;
    max-width: 600px;

    .name {
      font-size: 48px;
      font-weight: 700;
      margin-bottom: 12px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }

    .tagline {
      margin-bottom: 20px;

      .highlight {
        display: inline-block;
        padding: 6px 16px;
        background: rgba(102, 126, 234, 0.1);
        color: #667eea;
        border-radius: 20px;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0.5px;
      }
    }

    .job {
      font-size: 18px;
      line-height: 1.8;
      color: #666;
      margin-bottom: 32px;
    }

    .cta-buttons {
      display: flex;
      gap: 16px;
      justify-content: center;
      flex-wrap: wrap;

      .modern-btn {
        padding: 14px 32px;
        border-radius: 30px;
        font-size: 15px;
        font-weight: 600;
        text-decoration: none;
        transition: all 0.3s ease;
        cursor: pointer;
        display: inline-block;

        &.primary {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
          }
        }

        &.secondary {
          background: transparent;
          color: #667eea;
          border: 2px solid #667eea;

          &:hover {
            background: #667eea;
            color: white;
            transform: translateY(-2px);
          }
        }
      }
    }
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dark {
  .modern-home {
    .modern-details {
      .job {
        color: #aaa;
      }

      .tagline .highlight {
        background: rgba(102, 126, 234, 0.2);
        color: #8b9cff;
      }
    }
  }
}

@media (max-width: 768px) {
  .modern-home {
    .modern-avatar .avatar_img {
      width: 220px;
      height: 220px;
    }

    .modern-details {
      .name {
        font-size: 36px;
      }

      .job {
        font-size: 16px;
      }
    }
  }
}
</style>
